var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Duplicate and Edit'),expression:"'Duplicate and Edit'"}],staticClass:"small alternate",on:{"click":function($event){$event.preventDefault();return _vm.onDuplicateProject()}}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/icons/duplicate.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }